module.exports = __webpack_public_path__ + "img/6.b940ba58.jpg";